module.exports = __webpack_public_path__ + "img/6_91.427c1a86.png";